// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../core/Request.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function queryResultToAsyncResult(queryResult) {
  let data = queryResult.data;
  let exit = 0;
  if (data !== undefined) {
    let data$1 = Primitive_option.valFromOption(data);
    let exit$1 = 0;
    if (queryResult.error !== undefined) {
      exit$1 = 2;
    } else {
      if (!queryResult.loading) {
        return {
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: data$1
          }
        };
      }
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      if (queryResult.loading) {
        switch (queryResult.networkStatus) {
          case "Loading" :
            return {
              TAG: "Done",
              _0: {
                TAG: "Ok",
                _0: data$1
              }
            };
          case "SetVariables" :
            return {
              TAG: "Reloading",
              _0: {
                TAG: "Ok",
                _0: data$1
              }
            };
          default:
            exit = 1;
        }
      } else {
        exit = 1;
      }
    }
  } else if (queryResult.error !== undefined) {
    exit = 1;
  } else {
    if (!queryResult.loading) {
      return "NotAsked";
    }
    exit = 1;
  }
  if (exit === 1) {
    let match = queryResult.previousData;
    let exit$2 = 0;
    if (match !== undefined && match.TAG === "Ok" && queryResult.loading) {
      let data$2 = match._0;
      switch (queryResult.networkStatus) {
        case "Loading" :
          return {
            TAG: "Done",
            _0: {
              TAG: "Ok",
              _0: data$2
            }
          };
        case "SetVariables" :
        case "FetchMore" :
          return {
            TAG: "Reloading",
            _0: {
              TAG: "Ok",
              _0: data$2
            }
          };
        default:
          exit$2 = 2;
      }
    } else {
      exit$2 = 2;
    }
    if (exit$2 === 2) {
      if (queryResult.loading) {
        return "Loading";
      } else {
        return {
          TAG: "Done",
          _0: {
            TAG: "Error",
            _0: queryResult.error
          }
        };
      }
    }
  }
}

function useQueryResultToAsyncResult(queryResult, loading, onDone) {
  let asyncResult = queryResultToAsyncResult(queryResult);
  React.useEffect(() => {
    if (loading && typeof asyncResult === "object" && asyncResult.TAG === "Done") {
      onDone();
    }
  }, [asyncResult]);
  if (typeof asyncResult !== "object" || !(asyncResult.TAG === "Reloading" && loading)) {
    return asyncResult;
  } else {
    return "Loading";
  }
}

function useQueryResultToAsyncResultWithVariablesReloading1(queryResult, variableA) {
  let loadingRef = React.useRef(true);
  React.useEffect(() => {
    loadingRef.current = true;
  }, [variableA]);
  return useQueryResultToAsyncResult(queryResult, loadingRef.current, () => {
    loadingRef.current = false;
  });
}

function useQueryResultToAsyncResultWithVariablesReloading2(queryResult, variableA, variableB) {
  let loadingRef = React.useRef(true);
  React.useEffect(() => {
    loadingRef.current = true;
  }, [
    variableA,
    variableB
  ]);
  return useQueryResultToAsyncResult(queryResult, loadingRef.current, () => {
    loadingRef.current = false;
  });
}

function useQueryResultToAsyncResultWithVariablesReloading3(queryResult, variableA, variableB, variableC) {
  let loadingRef = React.useRef(true);
  React.useEffect(() => {
    loadingRef.current = true;
  }, [
    variableA,
    variableB,
    variableC
  ]);
  return useQueryResultToAsyncResult(queryResult, loadingRef.current, () => {
    loadingRef.current = false;
  });
}

function mutationPromiseToFutureResult(response) {
  return Future.map(FuturePromise.fromPromise(response), undefined, mutation => {
    if (mutation.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: Request.serverErrorMessage
      };
    }
    let error = mutation._0;
    if (error.TAG === "Ok") {
      let match = error._0;
      let error$1 = match.error;
      if (error$1 !== undefined) {
        return {
          TAG: "Error",
          _0: error$1.message
        };
      } else {
        return {
          TAG: "Ok",
          _0: match.data
        };
      }
    }
    let error$2 = error._0;
    let match$1 = error$2.networkError;
    if (match$1 !== undefined && match$1.TAG === "FetchFailure") {
      return {
        TAG: "Error",
        _0: Stdlib_Option.getExn(match$1._0.message, undefined)
      };
    } else {
      return {
        TAG: "Error",
        _0: error$2.message
      };
    }
  });
}

function mergeFutureResults(all) {
  return Future.map(Future.all(all), undefined, results => {
    let match = results[0];
    let match$1 = results.every(result => result.TAG === "Ok");
    if (match !== undefined && match.TAG === "Ok" && match$1) {
      return {
        TAG: "Ok",
        _0: match._0
      };
    } else {
      return {
        TAG: "Error",
        _0: Request.serverErrorMessage
      };
    }
  });
}

export {
  queryResultToAsyncResult,
  useQueryResultToAsyncResultWithVariablesReloading1,
  useQueryResultToAsyncResultWithVariablesReloading2,
  useQueryResultToAsyncResultWithVariablesReloading3,
  mutationPromiseToFutureResult,
  mergeFutureResults,
}
/* react Not a pure module */
